import { Dialog, Transition } from "@headlessui/react"
import { XIcon } from "@heroicons/react/outline";
import { Fragment, ReactNode } from "react";
import { capitalizeFirstLetter } from "utills/helpers";

interface IModalProps {
  title: string;
  open: boolean;
  closeOnClickBackdrop?: boolean;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
}

export const RightSideModal = ({open, onClose, children, title, closeOnClickBackdrop = false, footer}: IModalProps) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      {/* BACKDROP */}
      <Dialog 
        as="div" 
        className="relative z-50"
        onClose={() => closeOnClickBackdrop ? onClose() : null}
      > 
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 flex flex-row-reverse">
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="translate-x-full"
          >
            <Dialog.Panel className="relative flex w-full max-w-xl flex-1">
              <div className="w-full flex flex-col overflow-y-auto bg-white ring-1 ring-white/10">
                <div className="sticky top-0 z-10 bg-white shadow-sm flex h-16 shrink-0 px-4 py-4 sm:px-6 items-center justify-between border-b border-b-gray-100">
                  <p className="font-medium">{capitalizeFirstLetter(title ?? "")}</p>
                  <div className="">
                    <button 
                      type="button" 
                      onClick={onClose}
                    >
                      <span className="sr-only">Close Modal</span>
                      <XIcon className="h-5 w-5 text-gray-900" aria-hidden="true" />
                    </button>
                  </div>
                </div>
                <div className="flex flex-1 flex-col gap-y-2 mt-4">
                  {children}
                </div>
                {footer ? (
                  <div className="sticky bottom-0 z-[1] bg-white flex shrink-0 px-4 py-4 sm:px-6 items-center justify-between border-b border-b-gray-100" style={{boxShadow: "0 5px 0.75rem #686d71"}}>
                    {footer}
                  </div>
                ) : <></>}
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}